<div class="ssoMgmt">
    <div class="ssoMgmt-heading">
        <h3> {{ 'Sso.Management.heading' | localize:{whitelabel: whiteLabel} }} </h3>
    </div>
    <p class="ssoMgmt-description"> {{ 'Sso.Management.description' | localize:{whitelabel: whiteLabel} }} </p>
    <div class="card">
        <div class="card-lhp cardCol">
            <div>
                <label>{{ 'Sso.Management.date.label' | localize }}</label>
                <agpr-date-picker
                    [id]="id +'_expirationDate'"
                    [(ngModel)]="expirationDate"
                    [ariaLabelledBy]="id + '_expirationDate'"
                    [minDate]="minDate"
                ></agpr-date-picker>
            </div>
            <ng-container *ngIf="auths.length === 0">
                <agpr-checkbox
                    [id]="id + '_confirmation_checkbox'"
                    label="Sso.Management.confirmation"
                    [binary]="true"
                    [(ngModel)]="confirmation"
                ></agpr-checkbox>
                <div class="card-footer">
                    <agpr-button
                        [id]="id + '_authorize_button'"
                        label="Sso.Management.authorize"
                        [disabled]="!confirmation"
                        (click)="authorize()"
                        [style]="buttonTypes.primary"
                    ></agpr-button>
                </div>
            </ng-container>
        </div>
        <div class="card-rhp cardCol">
            <table class="table">
                <thead>
                    <tr class="tableHeader">
                        <th>
                            <span>{{ "Sso.Management.current.auth" | localize }}</span>
                        </th>
                        <th>
                            <span>{{ "Sso.Management.expiry" | localize }}</span>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="tableBody">
                    <tr
                        *ngFor="let auth of auths"
                    >
                        <td class="tableBody-label">
                            <label>{{ auth.label }}</label>
                        </td>
                        <td class="tableBody-expiry">
                            <label>{{ auth.date | date }}</label>
                        </td>
                        <td class="tableBody-icon">
                            <agpr-button
                                [id]="id + '_deleteAuth'"
                                icon="fa-regular fa-duotone fa-trash-can"
                                [style]="buttonTypes.icon"
                                tooltip="Sso.Management.delete.tooltip"
                                tooltipPosition="top"
                                (click)="deleteAuth(auth)"
                            ></agpr-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
